import Qs from 'qs'

const handledEntries = new Set()

export function entryKey (query) {
  return JSON.stringify([query.userId || '', query.envKey || '', query.ticket || '', query.pid || '', query.time || ''])
}

export function wasEntryHandled (key) { return handledEntries.has(key) }
export function markEntryHandled (key) { handledEntries.add(key) }

function requireSuccess (res) {
  if (!res || res.result !== '1') throw new Error((res && res.desc) || '检测状态查询失败，请重试')
  return res.data
}

// Only resolve a record belonging to the authenticated user's product list.
export async function resolvePidEntry (http, value) {
  const pid = String(value || '').trim()
  if (!pid) return null
  let product = null
  for (let pageNum = 1; ; pageNum++) {
    const page = requireSuccess(await http.post('/eps/getSnList', Qs.stringify({ pageNum, pageSize: 50 }), { timeout: 15000 }))
    if (!page || !Array.isArray(page.list)) throw new Error('检测列表返回异常，请重试')
    product = page.list.find(item => String(item.serialNum || '') === pid && item.id)
    if (product) break
    if (page.hasNextPage === false || Number(page.total) <= pageNum * 50) break
    if (!page.list.length || !Number.isFinite(Number(page.total)) || pageNum >= 1000) throw new Error('无法确认检测状态，请重试')
  }
  const intake = { path: '/intake', query: { pid, mode: 'create' } }
  if (!product) {
    const existing = requireSuccess(await http.get('/eps/getSnIdBySerialNum', { params: { serialNum: pid }, timeout: 15000 }))
    if (existing && existing.id) throw new Error('当前账号未关联此检测，请确认登录账号或联系客服')
    return intake
  }
  const detail = requireSuccess(await http.post('/eps/snDetail', Qs.stringify({ snId: product.id }), { timeout: 15000 }))
  if (!detail || String(detail.id) !== String(product.id) || String(detail.serialNum) !== pid) throw new Error('检测详情不匹配，请重试')
  const query = { patientId: product.patientId || '', serialNum: pid }
  if (detail.reportPdfUrl) return { path: '/report', query: Object.assign({ pid }, query) }
  // Registration is determined by the saved record, not today's required form fields.
  if (product.patientId || Number(detail.status) > 1) return { path: '/projects/' + encodeURIComponent(product.id), query }
  return intake
}



// WEBPACK FOOTER //
// ./src/utils/entryRouting.js